import { Locale } from '../../core/integrations/locale/locale';
import { CheerfyPayMenuPage } from '../../core/pages/cheerfy-pay-menu.page';

Locale.loadTranslations()
    .then(() => {
        const page = (new CheerfyPayMenuPage()).render();
    });
